import React, { memo, useRef, useState } from "react";
// import component
import FormikContainer from "../Formik/FormikContainer";
import DButton from "../DButton";
import FieldContainer from "../Formik/FieldContainer";
import { Form } from "formik";
import DCard from "../DCard";
import { Spinner } from "@chakra-ui/react";
import { useQuery, useQueryClient } from "react-query";
import userServices from "../../services/users";
import DSpinner from "../DSpinner";
import Table from "../Table";
import {
  availableSorrundWithButton,
  formattedLevel,
} from "../../utils/functions";
import moment from "moment";
import toast from "react-hot-toast";
import { Navigate, useSearchParams } from "react-router-dom";

const ColumnsSearch = [
  { key: "id", value: "الآيدي" },
  { key: "name", value: "الاسم" },
  { key: "username", value: "اسم المستخدم" },
];
const userColumns = [
  { Header: "الرقم التعريقي (ID)", accessor: "id" },
  { Header: "اسم المستخدم", accessor: "username" },
  { Header: "الاسم", accessor: "name" },
  { Header: "تاريخ الانشاء", accessor: "created_at" },
  { Header: "الرصيد", accessor: "balance" },
  { Header: "المستوى", accessor: "level" },
  { Header: "متاح/غير متاح", accessor: "is_available" },
  { Header: "التحكم", accessor: "actions" },
];
const CustomPriceForm = ({
  onSubmit,
  initialValues,
  validationSchema,
  subitemId,
  isUpdate,
  btnText,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const searchRef = useRef();
  const selectRef = useRef();
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("id") || "");
  const [searchParam, setSearchParam] = useState("id");
  const queryClient = useQueryClient();
  const handleSelectChange = () => {
    setSearchParam(selectRef.current.value);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(false);
    if (searchRef.current.value.trim() !== "") {
      setSearchQuery(searchRef.current.value);
    } else {
      setSearchQuery("");
    }
    queryClient.refetchQueries("getUsers");
  };

  const { data, isLoading, error } = useQuery(
    ["getUsers", currentPage, searchParam, searchQuery],
    () =>
      userServices.getAllUsersWithSearch(
        currentPage + 1,
        searchParam,
        searchQuery
      ),
    { staleTime: Infinity }
  );

  const copyUserId = (id) => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        toast.success("تم نسخ الرقم بنجاح!");
      })
      .catch((err) => {
        toast.error("حدث خطأ أثناء النسخ:", err);
      });
  };

  const formattedUserData = (data) => {
    if (data?.length > 0) {
      return data
        .map((d) => ({
          ...d,
          is_available: d.is_available === 1 ? "متاح" : "غير متاح",
          created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
          level: formattedLevel(d.level),
          actions: (
            <div className="flex items-center justify-center gap-2">
              <DButton
                onClick={() => copyUserId(d.id)}
                bgColor="primary"
                className=" px-4 text-white  rounded-[50px_!important]"
              >
                نسخ الرقم التعريفي
              </DButton>
            </div>
          ),
        }))
        .slice(0, 10);
    }
    return [];
  };

  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <DCard>
      <div>
        <form
          className="flex  max-lg:justify-center   flex-wrap gap-4 "
          onSubmit={handleSubmit}
        >
          <input
            type="text"
            ref={searchRef}
            className="  px-[10px] relative max-lg:py-1 max-lg:w-full  border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
            placeholder="البحث عن  ..."
          />
          <select
            className=" px-[10px] relative  text-gray-700   max-lg:w-full border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
            value={searchParam}
            ref={selectRef}
            onChange={handleSelectChange}
          >
            {ColumnsSearch.map((d, index) => (
              <option className="" key={index} value={d.key}>
                {d.value}
              </option>
            ))}
          </select>
          <DButton
            bgColor="success"
            className=" px-4 max-lg:mb-2  max-lg:w-full     text-white"
            type="submit"
          >
            {" "}
            بحث
          </DButton>
        </form>
      </div>
      <FormikContainer
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, isSubmitting, setFieldValue }) => (
          <Form>
            <div>
              <div className="mb-4">
                <FieldContainer
                  name="subitem_id"
                  type="text"
                  value={initialValues.subitem_id}
                  label="الرقم التعريفي للمنتج الفرعي"
                  id="subitem_id"
                  disabled
                />
              </div>
              <div className="">
                <FieldContainer
                  name="custom_price"
                  type="text"
                  value={values.custom_price}
                  label="السعر المخصص"
                  id="custom_price"
                />
                <FieldContainer
                  name="user_id"
                  type="text"
                  value={values.user_id}
                  disabled={isUpdate}
                  label="الرقم التعريفي للمستخدم "
                  id="user_id"
                />
                {!isUpdate && (
                  <>
                    {isLoading ? (
                      <DSpinner />
                    ) : (
                      <DCard className="min-h-[400px] relative mb-4">
                        <Table
                          head={userColumns}
                          body={formattedUserData(data.data.data.data)}
                          elements={{
                            is_available: availableSorrundWithButton,
                          }}
                          currentPage={currentPage}
                          enableSearch={false}
                          setCurrentPage={setCurrentPage}
                        />
                      </DCard>
                    )}
                  </>
                )}
              </div>
            </div>
            <DButton
              disabled={isSubmitting}
              type="submit"
              className="mx-auto min-w-[150px] rounded-lg  flex items-center justify-center text-white"
            >
              {isSubmitting ? <Spinner /> : btnText}
            </DButton>
          </Form>
        )}
      </FormikContainer>
    </DCard>
  );
};

export default memo(CustomPriceForm);
